import {
  GET_ALL_NOTIFICATIONS,
  GET_UNREAD_NOTIFICATIONS,
  GET_READ_NOTIFICATION,
} from "../../actionTypes";

const initialState = {
  notifications: [],

  // next: "",
  // last: "",
  // prev: "",
  // currentPage: 1,
  // perPage: null,
  others: {},
  unreadNotifications: [],
  // readNotifications: [],
};

export const notificationsReducer = (state = initialState, action) => {
  const { type, payload } = action;
  // console.log("TYPE", type);
  switch (type) {
    case GET_ALL_NOTIFICATIONS:
      return {
        ...state,
        notifications: payload.notifications,
        // notifications: [
        //   ...payload.notifications.data,
        //   payload.notifications.data,
        // ],
        // next: payload.notifications.next_page_url,
        // prev: payload.notifications.prev_page_url,
        // last: payload.notifications.last_page,
        // perPage: payload.notifications.per_page,
        // currentPage: payload.notifications.current_page,
        others: payload,
      };

    case GET_UNREAD_NOTIFICATIONS:
      return {
        ...state,
        unreadNotifications: payload.data,
      };

      // case GET_READ_NOTIFICATION:
      // return {
      //   ...state,
      //   readNotifications: payload.data,
      // };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/actions/notifications/notification.reducer.js